var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.502,
    height: 245.92,
    viewBox: "0 0 384.502 245.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_virtual_reality_re_yg8i",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15478",
    "data-name": "Path 15478",
    d: "M268.66,587.063c-1.625-13.068-9.724-25.944-22.187-30.2a60.674,60.674,0,0,1,0,41.657c-1.915,5.18-4.585,10.742-2.783,15.964a13.563,13.563,0,0,0,6.928,7.288,40.281,40.281,0,0,0,9.826,3.021l.661.547C266.433,613.3,270.285,600.131,268.66,587.063Z",
    transform: "translate(98.29 -381.276)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15479",
    "data-name": "Path 15479",
    d: "M258.762,556.824a51.861,51.861,0,0,1,12.892,29.187A22.333,22.333,0,0,1,271.4,593a12.809,12.809,0,0,1-3.186,5.941,26.509,26.509,0,0,0-4.115,4.924,7.843,7.843,0,0,0-.383,6.4,20.378,20.378,0,0,0,4.515,6.735c2.021,2.235,4.156,4.524,5.015,7.487.1.359.655.177.551-.182-1.495-5.155-6.5-8.083-8.886-12.727a7.943,7.943,0,0,1-.537-6.969c.913-2,2.615-3.494,4.082-5.079a13.668,13.668,0,0,0,3.331-5.693,20.646,20.646,0,0,0,.522-6.957,50.314,50.314,0,0,0-3.675-15.29,52.779,52.779,0,0,0-9.49-15.209c-.248-.278-.631.159-.384.435Z",
    transform: "translate(85.878 -380.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15480",
    "data-name": "Path 15480",
    d: "M251.646,601.018a7.781,7.781,0,0,0,5.923-8.151.29.29,0,0,0-.58.029,7.2,7.2,0,0,1-5.524,7.57c-.363.086-.179.637.182.551Z",
    transform: "translate(105.729 -399.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15481",
    "data-name": "Path 15481",
    d: "M275.368,632.722a15,15,0,0,1-6.7-8.637c-.105-.359-.656-.176-.551.182a15.6,15.6,0,0,0,6.987,8.973c.322.191.581-.328.261-.518Z",
    transform: "translate(79.558 -415.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15482",
    "data-name": "Path 15482",
    d: "M278.791,577.008a4.4,4.4,0,0,1-4.174-.212c-.319-.195-.578.325-.261.518a4.935,4.935,0,0,0,4.617.245.3.3,0,0,0,.185-.367.292.292,0,0,0-.367-.185Z",
    transform: "translate(72.911 -391.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15483",
    "data-name": "Path 15483",
    d: "M258.7,603.069c.2.127.392.255.588.387a58.01,58.01,0,0,1,7.416,5.79c.181.162.363.328.539.495a61.146,61.146,0,0,1,13.28,18.178,59.382,59.382,0,0,1,3.253,8.416c1.2,3.982,2.185,8.4,4.56,11.653a10.2,10.2,0,0,0,.794.98H310.6c.049-.024.1-.044.147-.069l.857.039c-.034-.152-.073-.309-.108-.46-.02-.088-.044-.176-.064-.265-.015-.059-.029-.118-.039-.171,0-.02-.01-.039-.015-.054-.01-.054-.025-.1-.034-.152q-.323-1.315-.666-2.63s0,0,0-.01a87.31,87.31,0,0,0-7.348-19.29c-.1-.181-.2-.367-.3-.549a56.663,56.663,0,0,0-5.09-7.72,50.1,50.1,0,0,0-3.336-3.816,41.654,41.654,0,0,0-10.424-7.808c-7.7-4.066-16.615-5.623-24.845-3.14C259.121,602.937,258.915,603,258.7,603.069Z",
    transform: "translate(48.069 -404.137)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15484",
    "data-name": "Path 15484",
    d: "M259.16,604.464a51.86,51.86,0,0,1,27.866,15.542,22.334,22.334,0,0,1,4.007,5.736,12.808,12.808,0,0,1,1.033,6.661,26.51,26.51,0,0,0-.321,6.409,7.843,7.843,0,0,0,3.549,5.343,20.376,20.376,0,0,0,7.66,2.659c2.959.568,6.042,1.11,8.512,2.959.3.224.629-.253.331-.477-4.3-3.216-10.056-2.541-14.757-4.812a7.943,7.943,0,0,1-4.625-5.241c-.475-2.147-.016-4.364.2-6.513a13.668,13.668,0,0,0-.768-6.551,20.646,20.646,0,0,0-3.772-5.869,50.312,50.312,0,0,0-12.139-10,52.779,52.779,0,0,0-16.734-6.43c-.365-.073-.408.507-.045.579Z",
    transform: "translate(47.662 -405.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15485",
    "data-name": "Path 15485",
    d: "M311.388,620.674a7.781,7.781,0,0,0-.178-10.074c-.248-.279-.694.092-.445.372a7.2,7.2,0,0,1,.147,9.371C310.673,620.631,311.151,620.96,311.388,620.674Z",
    transform: "translate(21.061 -408.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15486",
    "data-name": "Path 15486",
    d: "M309.246,656.895a15,15,0,0,1-10.547-2.864c-.3-.223-.63.254-.331.477a15.6,15.6,0,0,0,10.981,2.958c.372-.041.266-.612-.1-.571Z",
    transform: "translate(30.725 -430.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15487",
    "data-name": "Path 15487",
    d: "M345.73,612.154a4.4,4.4,0,0,1-3.46,2.344c-.372.036-.266.607.1.571a4.935,4.935,0,0,0,3.833-2.584.3.3,0,0,0-.073-.4.292.292,0,0,0-.4.073Z",
    transform: "translate(-27.398 -409.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15488",
    "data-name": "Path 15488",
    d: "M385.632,461.9l-5.692-1.915,4.678-22.866,8.4,2.826Z",
    transform: "translate(-194.629 -223.001)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15489",
    "data-name": "Path 15489",
    d: "M619.64,677.919l-1.6-.539-5.4-4.648-4.208,1.416h0a7.537,7.537,0,0,0-9.547,4.74l-.078.232,18.353,6.175Z",
    transform: "translate(-426.559 -440.385)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15490",
    "data-name": "Path 15490",
    d: "M352.6,456.555l-5.844,1.382-8.111-21.884,8.625-2.04Z",
    transform: "translate(-133.983 -221.413)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15491",
    "data-name": "Path 15491",
    d: "M558.208,673.088l-1.645.389-7.04-1.093L546.7,675.81h0a7.538,7.538,0,0,0-5.6,9.069l.056.238L560,680.661Z",
    transform: "translate(-338.55 -440.207)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3014",
    "data-name": "Rectangle 3014",
    width: 10.31,
    height: 17.085,
    transform: "translate(258.074 214.864)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3015",
    "data-name": "Rectangle 3015",
    width: 2.357,
    height: 29.903,
    transform: "matrix(-0.561, -0.827, 0.827, -0.561, 235.169, 242.645)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3016",
    "data-name": "Rectangle 3016",
    width: 29.903,
    height: 2.357,
    transform: "matrix(-0.827, -0.561, 0.561, -0.827, 291.287, 242.646)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_798",
    "data-name": "Ellipse 798",
    cx: 3.24,
    cy: 3.24,
    rx: 3.24,
    ry: 3.24,
    transform: "translate(231.269 238.43)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_799",
    "data-name": "Ellipse 799",
    cx: 3.24,
    cy: 3.24,
    rx: 3.24,
    ry: 3.24,
    transform: "translate(260.136 238.43)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_800",
    "data-name": "Ellipse 800",
    cx: 3.24,
    cy: 3.24,
    rx: 3.24,
    ry: 3.24,
    transform: "translate(288.709 238.43)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3017",
    "data-name": "Rectangle 3017",
    width: 2.357,
    height: 16.79,
    transform: "translate(262.198 224.879)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 4.419,
    height: 22.682,
    transform: "translate(261.02 199.841)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15492",
    "data-name": "Path 15492",
    d: "M451.537,604.232v-5.3a3.686,3.686,0,0,0-3.682-3.682H413.424a3.686,3.686,0,0,0-3.682,3.682v5.3a3.686,3.686,0,0,0,3.682,3.682h34.431a3.686,3.686,0,0,0,3.682-3.682Z",
    transform: "translate(-165.845 -400.855)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15493",
    "data-name": "Path 15493",
    d: "M331.875,544.531,354.1,506.309a5.441,5.441,0,0,0-1.966-7.43l-1.3-.756a5.44,5.44,0,0,0-7.43,1.965L321.18,538.311a5.44,5.44,0,0,0,1.966,7.43l1.3.756A5.44,5.44,0,0,0,331.875,544.531Z",
    transform: "translate(-25.405 -350.933)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15494",
    "data-name": "Path 15494",
    d: "M383.478,594.34A18.145,18.145,0,0,0,401.6,576.216h-1.959a16.167,16.167,0,0,1-25.475,13.216l-1.13,1.6a18.008,18.008,0,0,0,10.44,3.308Z",
    transform: "translate(-97.931 -391.147)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15495",
    "data-name": "Path 15495",
    d: "M503.07,550.588s-54.863-16.655-63.19,3.919-16.165,44.086-16.165,44.086l10.777,3.429,21.063-35.269s50.77,12.736,61.389-2.2Z",
    transform: "translate(-238.096 -374.825)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15496",
    "data-name": "Path 15496",
    d: "M392.941,471.2l12.736-.98,2.449,15.675s-15.675,40.657-42.616,44.576l-25.472-23.023,28.21-10.511Z",
    transform: "translate(-88.29 -337.071)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_801",
    "data-name": "Ellipse 801",
    cx: 16.652,
    cy: 16.652,
    rx: 16.652,
    ry: 16.652,
    transform: "translate(321.04 132.245) rotate(-153.47)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15497",
    "data-name": "Path 15497",
    d: "M320.209,417.331a5.65,5.65,0,0,0,3.512,1.031,21.315,21.315,0,0,0,21.02-15,14.2,14.2,0,0,0,.141-8.791,18.6,18.6,0,0,0-3.875-5.861c-1.251-1.41-2.556-2.792-3.88-4.106a16.173,16.173,0,0,0-5.832-4.134,17.932,17.932,0,0,0-5.386-.705c-.626-.018-1.273-.037-1.9-.079a11.118,11.118,0,0,1-4.506-1.124,2.288,2.288,0,0,0-1.894-.122,2.328,2.328,0,0,0-1.36,1.371c-.227.615-.432,1.169-1.127,1.373a1.587,1.587,0,0,1-1.45-.332.821.821,0,0,0-.766-.168.837.837,0,0,0-.569.539l-.057.169a1.068,1.068,0,0,0-.987-.119,1.1,1.1,0,0,0-.715,1.169,10.975,10.975,0,0,0,2.307,5.578,10.689,10.689,0,0,0,3.2,2.664l.2.109.136-.205c5.534,2.045,7.224,7.843,6.951,12.627l.484.065a1.185,1.185,0,0,1,.556-.746,1.44,1.44,0,0,1,1.088-.189,1.865,1.865,0,0,1,1.3,1.613,2.769,2.769,0,0,1-.765,2.1,7.513,7.513,0,0,1-1.98,1.412c-.332.188-.676.382-1,.595a8.969,8.969,0,0,0-3.733,5.2,4.293,4.293,0,0,0,.346,3.462A2.974,2.974,0,0,0,320.209,417.331Z",
    transform: "translate(-11.251 -290.173)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15498",
    "data-name": "Path 15498",
    d: "M548.038,577.712a343.273,343.273,0,0,0,8.045,42.676l10.287-1.47-2.343-41.574",
    transform: "translate(-348.421 -391.722)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15499",
    "data-name": "Path 15499",
    d: "M374.8,412.174a2.307,2.307,0,0,0,2.2-1.623c6.684-3.483,3.15-5.94,2.69-8.705a2.3,2.3,0,0,0-1.52-2.879l-6.833-2.112a2.3,2.3,0,0,0-2.88,1.52l-2.69,8.705a2.3,2.3,0,0,0,1.52,2.879l6.833,2.112a2.3,2.3,0,0,0,.678.1Z",
    transform: "translate(-73.746 -299.593)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15500",
    "data-name": "Path 15500",
    d: "M388.165,396.347a2.315,2.315,0,0,0-2.228,1.632l-2.834,8.9a2.408,2.408,0,0,0,.134,1.805,2.3,2.3,0,0,0,1.337,1.177l1.536.515,4.266-13.4-1.536-.515A2.239,2.239,0,0,0,388.165,396.347Z",
    transform: "translate(-91.581 -299.386)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15501",
    "data-name": "Path 15501",
    d: "M343.244,422.928a1.491,1.491,0,0,0,1.423-1.049l.712-2.3a1.489,1.489,0,0,0-.983-1.862l-30.852-9.534a1.489,1.489,0,0,0-1.862.983l-.712,2.3a1.49,1.49,0,0,0,.983,1.862l30.852,9.534A1.481,1.481,0,0,0,343.244,422.928Z",
    transform: "translate(-11.338 -305.389)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15502",
    "data-name": "Path 15502",
    d: "M474.128,566.329h4.6a2.31,2.31,0,0,0,2.306-2.181l.78-13.85a2.309,2.309,0,0,0-2.306-2.439h-6.157a2.308,2.308,0,0,0-2.306,2.439l.78,13.85A2.31,2.31,0,0,0,474.128,566.329Z",
    transform: "translate(-226.148 -376.68)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15503",
    "data-name": "Path 15503",
    d: "M263.369,356l.059,1.026h10.307l.059-1.026Z",
    transform: "translate(-18.303 -181.615)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15504",
    "data-name": "Path 15504",
    d: "M263.636,360.714l.056,1.026h10.051l.057-1.026Z",
    transform: "translate(-18.439 -184.02)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15505",
    "data-name": "Path 15505",
    d: "M263.9,365.427l.059,1.026h9.789l.059-1.026Z",
    transform: "translate(-18.573 -186.424)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15506",
    "data-name": "Path 15506",
    d: "M264.165,370.141l.059,1.026h9.527l.059-1.026Z",
    transform: "translate(-18.709 -188.829)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15507",
    "data-name": "Path 15507",
    d: "M264.433,374.854l.056,1.026h9.271l.056-1.026Z",
    transform: "translate(-18.846 -191.233)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15508",
    "data-name": "Path 15508",
    d: "M264.694,379.567l.059,1.026h9.009l.059-1.026Z",
    transform: "translate(-18.979 -193.638)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_802",
    "data-name": "Ellipse 802",
    cx: 1.667,
    cy: 0.385,
    rx: 1.667,
    ry: 0.385,
    transform: "translate(248.483 171.307)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15509",
    "data-name": "Path 15509",
    d: "M476.4,540.9a.385.385,0,0,0,.385-.385v-7.288h2.435a.385.385,0,1,0,0-.77H476.4a.385.385,0,0,0-.385.385v7.673A.385.385,0,0,0,476.4,540.9Z",
    transform: "translate(-226.376 -368.823)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15510",
    "data-name": "Path 15510",
    d: "M431.375,560.848a4.926,4.926,0,0,1,7.422,1.4l17.233-3.07-3.6,8.354-15.813,1.634a4.952,4.952,0,0,1-5.243-8.322Z",
    transform: "translate(-180.035 -382.456)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15511",
    "data-name": "Path 15511",
    d: "M362.453,536.581l31.584-2.483.063-.119c.121-.228,12.088-22.9,13.848-28.1a14.539,14.539,0,0,0-.024-9.67l-.032-.076-.071-.041a7.378,7.378,0,0,0-9.116,1.43,52.261,52.261,0,0,0-11.555,21.005l-1.23,4.44-22.6,5.061Z",
    transform: "translate(-99.908 -349.774)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    d: "M845.468,220.094,704.795,199.561v134.7l140.673-20.532Z",
    transform: "translate(-704.306 -198.995)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15512",
    "data-name": "Path 15512",
    d: "M703.8,334.235,845.448,313.56V219.081L703.8,198.4Zm140.673-21.522L704.775,333.1V199.538l139.693,20.39Z",
    transform: "translate(-703.796 -198.405)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M809.929,291.577c.209-.476.428-.96.662-1.425a12.241,12.241,0,0,1,.756-1.317,5.847,5.847,0,0,1,.886-1.059,3.067,3.067,0,0,1,1.051-.652,2.523,2.523,0,0,1,1.326-.088,4.147,4.147,0,0,1,1.3.519,8.833,8.833,0,0,1,1.254.915c.406.347.8.725,1.176,1.1q1.678,1.677,3.306,3.4t3.187,3.466q1.558,1.744,3.069,3.531t2.957,3.595l0,.072-2.272-.282-2.3-.286-2.33-.289-2.359-.294c-.573-.071-1.152-.145-1.732-.24a16.276,16.276,0,0,1-1.737-.373,10.372,10.372,0,0,1-1.7-.632,8.573,8.573,0,0,1-1.624-1.013c-.2-.158-.4-.328-.6-.5s-.4-.335-.6-.484a3.856,3.856,0,0,0-.625-.383,2,2,0,0,0-.662-.192,1.764,1.764,0,0,0-.824.125,2.9,2.9,0,0,0-.766.469,5.559,5.559,0,0,0-.7.707,10.286,10.286,0,0,0-.63.839,33.018,33.018,0,0,0-3.014,5.761c-.882,2.088-1.666,4.289-2.475,6.471s-1.645,4.366-2.618,6.394a25.4,25.4,0,0,1-3.478,5.551q1.31-4.451,2.733-8.789,1.416-4.316,2.939-8.511,1.518-4.172,3.134-8.212,1.609-4.017,3.314-7.9Z",
    transform: "translate(-735.263 -243.595)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M759.021,293.834l.035.04.035.04.035.04.035.04q.128.105.255.214l.253.218.251.221.249.223q.234.21.465.424t.461.431q.229.217.457.441l.453.446q.448.447.887.909t.869.934q.43.474.851.963t.833.991q.214.26.424.524t.419.531q.208.267.413.539l.409.542.029-.049.029-.049.028-.049.026-.056.007-.013.007-.013.006-.013.006-.013a8.791,8.791,0,0,0,.679-1.763,10.809,10.809,0,0,0,.335-1.959,11.724,11.724,0,0,0-.017-2.039,11.163,11.163,0,0,0-.378-2.008,9.345,9.345,0,0,0-.713-1.794,7,7,0,0,0-.98-1.421,4.908,4.908,0,0,0-1.186-.975,3.559,3.559,0,0,0-1.332-.458A3.189,3.189,0,0,0,762.3,290a3.835,3.835,0,0,0-1.255.686,5.427,5.427,0,0,0-1.081,1.195,7.708,7.708,0,0,0-.836,1.653l0,.01,0,.011,0,.011,0,.01-.024.065-.023.066-.023.066Z",
    transform: "translate(-653.698 -245.055)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M810.792,387.968q-.778.087-1.56.215t-1.568.294q-.788.169-1.578.378t-1.586.46a39.245,39.245,0,0,0-4.789,1.88,45.077,45.077,0,0,0-4.778,2.608,52.258,52.258,0,0,0-4.729,3.343,60.589,60.589,0,0,0-4.634,4.08q-.761.74-1.51,1.519t-1.489,1.6q-.74.82-1.465,1.676t-1.44,1.754l-.175.22-.174.222-.174.223-.173.224a.142.142,0,0,1-.117.065.14.14,0,0,1-.1-.058.224.224,0,0,1-.046-.13.235.235,0,0,1,.049-.152q.71-.92,1.437-1.8t1.466-1.725q.735-.843,1.488-1.648t1.511-1.568q.759-.762,1.529-1.486t1.545-1.406q.775-.682,1.561-1.323t1.574-1.243q.79-.6,1.587-1.163t1.595-1.083q.8-.519,1.6-1t1.606-.918q.8-.436,1.606-.833t1.606-.749q.8-.354,1.605-.667t1.6-.585q.8-.271,1.594-.5t1.587-.418q.791-.188,1.579-.336t1.57-.255l.2-.026.2-.025.2-.023.2-.022a.088.088,0,0,1,.049.014.131.131,0,0,1,.039.04.209.209,0,0,1,.026.059.279.279,0,0,1,.01.074.292.292,0,0,1-.01.073.242.242,0,0,1-.026.063.16.16,0,0,1-.039.045.1.1,0,0,1-.049.021Z",
    transform: "translate(-705.957 -294.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M830.7,362.791q-1.391.2-2.8.4t-2.841.436q-1.434.231-2.882.49t-2.923.572q-1.479.294-2.968.668t-3,.825q-1.513.454-3.032.986t-3.059,1.155q-1.362.549-2.719,1.2t-2.716,1.4q-1.359.754-2.707,1.608t-2.694,1.815q-1.259.9-2.49,1.91t-2.439,2.131q-1.208,1.122-2.38,2.348t-2.311,2.561q-1.127,1.318-2.185,2.749t-2.057,2.978q-.995,1.547-1.913,3.194t-1.758,3.4q-.1.22-.207.441t-.2.445q-.1.223-.2.448t-.2.451a.2.2,0,0,1-.109.115.136.136,0,0,1-.121-.017.2.2,0,0,1-.079-.114.268.268,0,0,1,.018-.176q.794-1.8,1.679-3.521t1.851-3.32q.962-1.608,2-3.113t2.145-2.886q1.112-1.39,2.271-2.679t2.348-2.464q1.19-1.176,2.416-2.245t2.473-2.022q1.3-.992,2.619-1.887t2.639-1.683q1.322-.789,2.653-1.48t2.662-1.277q1.54-.672,3.077-1.258t3.052-1.078q1.519-.5,3.026-.908t2.994-.735q1.5-.343,2.98-.63t2.939-.534q1.454-.245,2.895-.464t2.85-.418l.35-.049.349-.049.349-.051.348-.049a.089.089,0,0,1,.092.049.256.256,0,0,1,.03.128.309.309,0,0,1-.031.138A.126.126,0,0,1,830.7,362.791Z",
    transform: "translate(-725.379 -282.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M778.232,349.83q.225-.392.449-.787l.447-.787q.223-.392.444-.787l.441-.787q1.789-3.2,3.505-6.4,1.707-3.189,3.342-6.391,1.627-3.184,3.184-6.383,1.551-3.184,3.037-6.381,1-2.163,1.978-4.332t1.91-4.329q.937-2.161,1.843-4.329t1.778-4.329q.415-1.029.824-2.057t.809-2.057q.4-1.029.795-2.057t.78-2.057q.3-.8.6-1.6t.588-1.6q.291-.8.578-1.6t.57-1.6l.161-.457q.08-.228.159-.457l.157-.457.156-.458.366-1.078q.183-.539.366-1.075t.371-1.068q.187-.532.379-1.059c.147-.4.3-.8.465-1.2s.343-.787.533-1.159a9.364,9.364,0,0,1,.623-1.048,5.726,5.726,0,0,1,.735-.872,3.006,3.006,0,0,1,.378-.322,2.618,2.618,0,0,1,.407-.239,2.357,2.357,0,0,1,.428-.153,2.23,2.23,0,0,1,.443-.065,2.113,2.113,0,0,1,.628.088,3.109,3.109,0,0,1,.6.253,5.4,5.4,0,0,1,.581.367c.19.136.376.283.559.432q2.006,1.648,3.919,3.435,1.9,1.774,3.7,3.68t3.481,3.911q1.682,2.005,3.265,4.131,1.577,2.106,3.052,4.314t2.832,4.492q1.358,2.283,2.614,4.661,1.247,2.363,2.393,4.818a.131.131,0,0,0,.087.083.108.108,0,0,0,.094-.03.2.2,0,0,0,.058-.106.233.233,0,0,0-.019-.147q-.139-.3-.28-.6t-.284-.591l-.286-.591q-.144-.3-.29-.588-1.816-3.661-3.861-7.109-2.057-3.472-4.347-6.714-2.305-3.267-4.838-6.289-2.555-3.046-5.335-5.829-.47-.47-.947-.931t-.961-.916q-.484-.454-.974-.9t-.988-.884l-.5-.441q-.252-.22-.506-.437t-.51-.431q-.256-.214-.515-.422a5.228,5.228,0,0,0-.512-.412,4.632,4.632,0,0,0-.539-.326,4.165,4.165,0,0,0-.559-.239,3.814,3.814,0,0,0-.575-.147,2.458,2.458,0,0,0-1.778.548,5.789,5.789,0,0,0-1.386,1.679,16.186,16.186,0,0,0-1.066,2.269c-.311.795-.581,1.594-.824,2.309l-.23.674q-.115.337-.232.674t-.233.674q-.117.337-.235.674-.446,1.279-.9,2.557t-.923,2.556q-.467,1.279-.945,2.556t-.967,2.556q-.3.79-.608,1.578t-.616,1.578q-.311.79-.625,1.578t-.631,1.577q-.994,2.462-2.027,4.916t-2.112,4.917q-1.078,2.464-2.2,4.921t-2.288,4.927q-1.55,3.274-3.171,6.534-1.63,3.277-3.331,6.541-1.715,3.282-3.5,6.555-1.8,3.291-3.678,6.574a.306.306,0,0,0-.039.184.28.28,0,0,0,.059.147.137.137,0,0,0,.111.057.153.153,0,0,0,.115-.088Z",
    transform: "translate(-734.798 -238.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M758.267,301.107l.106-.171.106-.171.106-.171.106-.171c.28-.448.565-.894.858-1.326s.595-.851.909-1.24a11.217,11.217,0,0,1,.98-1.084,7.035,7.035,0,0,1,1.078-.858,4.359,4.359,0,0,1,.55-.31,3.954,3.954,0,0,1,.567-.216,3.69,3.69,0,0,1,.58-.121,3.59,3.59,0,0,1,.588-.025,4.434,4.434,0,0,1,.6.1,4.682,4.682,0,0,1,.594.186,5.094,5.094,0,0,1,.581.267,5.641,5.641,0,0,1,.563.347q.131.087.261.179t.258.188l.255.2q.127.1.253.2.144.118.286.239t.284.245l.282.247.28.249q.262.235.522.473t.517.482l.512.49q.255.245.507.5.5.5.993,1.013t.972,1.043q.481.529.952,1.073t.931,1.1q.238.29.474.583t.468.591q.233.3.462.6t.456.606q.211.283.419.569t.414.576q.205.289.408.581t.4.588a.1.1,0,0,0,.091.053.119.119,0,0,0,.08-.059.245.245,0,0,0,.036-.123.224.224,0,0,0-.038-.136l-.106-.158-.106-.156-.107-.155-.107-.154q-.151-.217-.3-.433l-.306-.43q-.154-.214-.31-.427t-.313-.423q-.286-.386-.577-.764t-.588-.752q-.294-.371-.594-.738t-.606-.728q-.475-.563-.96-1.109t-.98-1.078q-.5-.533-1-1.048t-1.026-1.017q-.259-.25-.521-.5t-.526-.49q-.264-.242-.531-.48t-.536-.471l-.163-.14-.165-.138-.166-.136-.167-.133q-.19-.156-.383-.3t-.392-.277q-.2-.133-.4-.254t-.405-.231a4.48,4.48,0,0,0-.588-.269,4.082,4.082,0,0,0-.6-.173,3.843,3.843,0,0,0-.609-.076,3.773,3.773,0,0,0-.612.023,4.31,4.31,0,0,0-.588.138,4.593,4.593,0,0,0-.573.221,5.018,5.018,0,0,0-.556.3,5.575,5.575,0,0,0-.536.384,8.757,8.757,0,0,0-1.059.994,14.432,14.432,0,0,0-.967,1.192c-.31.423-.61.867-.9,1.323s-.581.918-.867,1.38a.255.255,0,0,0-.035.151.288.288,0,0,0,.044.136.132.132,0,0,0,.087.065A.1.1,0,0,0,758.267,301.107Z",
    transform: "translate(-663.834 -247.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M904.351,342.435l-4.376-2.117-2.209-1.068q-.269-.144-.541-.278t-.548-.26q-.276-.126-.555-.242t-.56-.224a2.762,2.762,0,0,0-.5-.137,2.662,2.662,0,0,0-1.016.019,2.829,2.829,0,0,0-.5.157,4.184,4.184,0,0,0-.431.245,4.532,4.532,0,0,0-.41.3,4.95,4.95,0,0,0-.386.354,5.373,5.373,0,0,0-.359.4q-.176.215-.346.437t-.334.454q-.164.231-.321.471t-.309.487l-.375.6q-.187.3-.373.6l-.373.6-.374.6q-.773,1.249-1.547,2.506t-1.554,2.53q-.779,1.274-1.56,2.554t-1.568,2.578l-1.573,2.6q-.79,1.306-1.58,2.627t-1.586,2.652q-.794,1.329-1.593,2.677t-1.6,2.709q-.8,1.359-1.609,2.734t-1.617,2.759q-.809,1.384-1.622,2.785l-.2.343-.2.343-.2.343-.2.343a.219.219,0,0,1-.134.11.182.182,0,0,1-.142-.024.2.2,0,0,1-.086-.12.239.239,0,0,1,.032-.177q.822-1.417,1.643-2.824t1.636-2.8q.815-1.391,1.629-2.772t1.623-2.743q.811-1.368,1.62-2.727t1.613-2.7q.8-1.343,1.607-2.676t1.6-2.651q.8-1.317,1.593-2.626t1.587-2.6q.791-1.292,1.58-2.576t1.573-2.551l.392-.631.392-.63.392-.628.392-.627.328-.529q.164-.264.331-.525t.338-.514q.171-.254.35-.5a10.02,10.02,0,0,1,.7-.857,6.1,6.1,0,0,1,.776-.72,3.729,3.729,0,0,1,.849-.5,2.61,2.61,0,0,1,.931-.2,4.735,4.735,0,0,1,.563.06,4.836,4.836,0,0,1,.555.126,5.019,5.019,0,0,1,.542.192,5.28,5.28,0,0,1,.526.257l.563.271.561.272.559.272.555.271,4.431,2.148,1.092.53a.191.191,0,0,1,.1.119.336.336,0,0,1,.007.163.229.229,0,0,1-.066.128A.106.106,0,0,1,904.351,342.435Z",
    transform: "translate(-843.812 -269.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M756.93,289.58l.2.245a7.666,7.666,0,0,1,1.466-2.033,5.012,5.012,0,0,1,1.773-1.14,3.939,3.939,0,0,1,1.921-.2,4.532,4.532,0,0,1,1.916.778,6.791,6.791,0,0,1,1.661,1.674,10.108,10.108,0,0,1,1.211,2.319,13.092,13.092,0,0,1,.693,2.758,14.32,14.32,0,0,1,.1,3,13.6,13.6,0,0,1-.185,1.489,12.412,12.412,0,0,1-.34,1.406,10.817,10.817,0,0,1-.487,1.3,9.036,9.036,0,0,1-.625,1.158l.173.27a9.428,9.428,0,0,0,.651-1.206,11.248,11.248,0,0,0,.507-1.349,12.894,12.894,0,0,0,.353-1.464,14.134,14.134,0,0,0,.193-1.55,14.911,14.911,0,0,0-.107-3.124,13.626,13.626,0,0,0-.72-2.871,10.53,10.53,0,0,0-1.259-2.414,7.077,7.077,0,0,0-1.728-1.744,4.721,4.721,0,0,0-1.995-.813,4.1,4.1,0,0,0-2,.207,5.215,5.215,0,0,0-1.847,1.185,7.978,7.978,0,0,0-1.528,2.12Z",
    transform: "translate(-652.527 -243.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M820.981,330.395a.756.756,0,0,0,.114-.127.955.955,0,0,0,.092-.157,1.15,1.15,0,0,0,.066-.182,1.293,1.293,0,0,0,.038-.2,1.359,1.359,0,0,0,.007-.207,1.33,1.33,0,0,0-.024-.2,1.218,1.218,0,0,0-.054-.189,1.018,1.018,0,0,0-.082-.169l.85-12.3-1.421.1-.4,12.148a1.044,1.044,0,0,0-.138.288,1.317,1.317,0,0,0-.056.33,1.345,1.345,0,0,0,.028.336,1.133,1.133,0,0,0,.113.309.8.8,0,0,0,.182.229.549.549,0,0,0,.217.121.464.464,0,0,0,.235,0A.562.562,0,0,0,820.981,330.395Z",
    transform: "translate(-737.246 -258.737)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M819.215,313.035l.375,4.1-.052,2.508,1.565.222.312-2.073.173-5.491a2.336,2.336,0,0,0-.063-.617,1.989,1.989,0,0,0-.207-.529,1.417,1.417,0,0,0-.324-.392.947.947,0,0,0-.411-.2h0a.8.8,0,0,0-.447.037,1.028,1.028,0,0,0-.387.271,1.55,1.55,0,0,0-.287.461,2.12,2.12,0,0,0-.147.609Z",
    transform: "translate(-736.474 -255.616)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M809.171,382.9l.923-.063.437-5.218-1.36.073Z",
    transform: "translate(-720.497 -289.83)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M806.381,389.151l2.963-.21v-.055a2.313,2.313,0,0,0-.09-.649,1.733,1.733,0,0,0-.245-.518,1.127,1.127,0,0,0-.365-.337.8.8,0,0,0-.448-.1h0l-1.815.12Z",
    transform: "translate(-717.943 -294.76)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M824.973,383.853l.962-.066.456-5.328-1.418.076Z",
    transform: "translate(-744.097 -290.261)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M822.066,390.238l3.086-.219v-.056a2.313,2.313,0,0,0-.094-.662,1.748,1.748,0,0,0-.256-.529,1.162,1.162,0,0,0-.38-.343.85.85,0,0,0-.466-.1h0l-1.89.125Z",
    transform: "translate(-741.435 -295.293)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    d: "M818.184,294.578a1.466,1.466,0,0,0-.8.189,2.045,2.045,0,0,0-.655.6,3.085,3.085,0,0,0-.441.922,4.026,4.026,0,0,0-.163,1.15,4.185,4.185,0,0,0,.163,1.165,3.44,3.44,0,0,0,.441.964,2.351,2.351,0,0,0,.655.663,1.576,1.576,0,0,0,.8.265,1.472,1.472,0,0,0,.8-.2,2.066,2.066,0,0,0,.648-.606,3.1,3.1,0,0,0,.436-.917,4.03,4.03,0,0,0,.159-1.139,4.193,4.193,0,0,0-.159-1.154,3.451,3.451,0,0,0-.435-.959,2.377,2.377,0,0,0-.648-.665A1.588,1.588,0,0,0,818.184,294.578Z",
    transform: "translate(-733.596 -247.467)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M813.488,309.135l-1.427.184h0a6.323,6.323,0,0,0-.431,1.133,7.367,7.367,0,0,0-.227,1.237,7.864,7.864,0,0,0-.021,1.287,7.674,7.674,0,0,0,.192,1.28l1.078,4.514s-.094.269-.234.735-.328,1.132-.515,1.923-.376,1.71-.516,2.682a21.157,21.157,0,0,0-.235,3.006,38.6,38.6,0,0,1-.449,4.584c-.27,1.923-.63,4.115-.991,6.182s-.724,4.022-1,5.454-.455,2.351-.455,2.351l4.056.36,1.744-15.3,2.376,14.983,2.676-.8-1.469-19.562-.977-6.478-.042-3.163s.026-.147.049-.392a7.881,7.881,0,0,0,.029-.98,6.261,6.261,0,0,0-.167-1.271,3.933,3.933,0,0,0-.539-1.265l-1.282-2.636Z",
    transform: "translate(-728.635 -254.895)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M818.439,296.2l-3-.15v-1.9a4.935,4.935,0,0,1,.49-.232,1.628,1.628,0,0,1,.461-.121.708.708,0,0,1,.409.079.874.874,0,0,1,.336.367,1.011,1.011,0,0,1,.508.177,1.52,1.52,0,0,1,.413.427,2.217,2.217,0,0,1,.278.613,2.688,2.688,0,0,1,.1.738Z",
    transform: "translate(-731.476 -247.069)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M819.528,293.818a1.4,1.4,0,0,0-1.127.478,3.565,3.565,0,0,0-.716,1.291,8.848,8.848,0,0,0-.376,1.66,12.039,12.039,0,0,0-.109,1.58,3.225,3.225,0,0,0,.059.66,1.46,1.46,0,0,0,.168.454.931.931,0,0,0,.264.288,1.127,1.127,0,0,0,.346.159l.18-1.372.422,1.455.109,0,.111,0h.229l.143-.416.317.427c.317.013.618.042.892.049a2.046,2.046,0,0,0,.724-.08.833.833,0,0,0,.486-.431,2.251,2.251,0,0,0,.179-1,13.03,13.03,0,0,0-.1-1.57,9.272,9.272,0,0,0-.353-1.678,3.922,3.922,0,0,0-.7-1.356A1.606,1.606,0,0,0,819.528,293.818Z",
    transform: "translate(-735.733 -247.08)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M814.914,323.551l.075-4.747.2-2.1.493,2.1Z",
    transform: "translate(-728.461 -258.754)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M821.234,319.261l2.273.023v-9.6l-2.273-.08a1.2,1.2,0,0,0-.643.165,1.69,1.69,0,0,0-.526.49,2.519,2.519,0,0,0-.356.744,3.229,3.229,0,0,0-.131.923v4.936a3.3,3.3,0,0,0,.131.928,2.653,2.653,0,0,0,.356.76,1.808,1.808,0,0,0,.526.515,1.243,1.243,0,0,0,.643.2Z",
    transform: "translate(-738.57 -255.135)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M823.269,314.6a.21.21,0,0,0,.112-.03.3.3,0,0,0,.091-.086.44.44,0,0,0,.062-.13.568.568,0,0,0,.023-.161v-3.58l-.575-.02v3.586a.579.579,0,0,0,.023.162.47.47,0,0,0,.063.133.32.32,0,0,0,.092.091.218.218,0,0,0,.112.035Z",
    transform: "translate(-740.287 -255.639)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M821.2,325.171l1.669.02a.266.266,0,0,0,.141-.039.381.381,0,0,0,.115-.11.565.565,0,0,0,.077-.164.714.714,0,0,0,.028-.2v-1.432a.726.726,0,0,0-.028-.2.586.586,0,0,0-.077-.166.4.4,0,0,0-.115-.115.273.273,0,0,0-.141-.044l-1.669-.031a.268.268,0,0,0-.142.039.382.382,0,0,0-.116.11.564.564,0,0,0-.078.165.716.716,0,0,0-.029.2v1.441a.724.724,0,0,0,.029.2.588.588,0,0,0,.078.167.4.4,0,0,0,.116.114A.275.275,0,0,0,821.2,325.171Z",
    transform: "translate(-738.912 -261.808)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M816.748,314.91a4.945,4.945,0,0,0,.294-.645,5.663,5.663,0,0,0,.211-.7,6.221,6.221,0,0,0,.125-.748,6.5,6.5,0,0,0,.035-.775,7.208,7.208,0,0,0-.152-1.487,5.222,5.222,0,0,0-.412-1.225,2.715,2.715,0,0,0-.612-.843,1.211,1.211,0,0,0-.751-.329,1.266,1.266,0,0,0-.454.1,1.537,1.537,0,0,0-.411.264,2.038,2.038,0,0,0-.351.409,2.675,2.675,0,0,0-.271.536l.162.152a2.416,2.416,0,0,1,.239-.482,1.846,1.846,0,0,1,.313-.368,1.393,1.393,0,0,1,.368-.242,1.143,1.143,0,0,1,.406-.1,1.078,1.078,0,0,1,.678.3,2.512,2.512,0,0,1,.553.782,4.943,4.943,0,0,1,.372,1.139,6.888,6.888,0,0,1,.136,1.381,6.1,6.1,0,0,1-.032.728,5.841,5.841,0,0,1-.116.7,5.324,5.324,0,0,1-.2.662,4.649,4.649,0,0,1-.275.606Z",
    transform: "translate(-729.745 -254.394)",
    fill: "#ca353b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M817.268,330.008a.877.877,0,0,0,.119-.147,1.1,1.1,0,0,0,.093-.182,1.3,1.3,0,0,0,.064-.2,1.443,1.443,0,0,0,.033-.221,1.509,1.509,0,0,0,0-.225,1.425,1.425,0,0,0-.034-.217,1.271,1.271,0,0,0-.066-.2,1.062,1.062,0,0,0-.1-.177l.419-13.451-1.535.224.069,13.262a1.192,1.192,0,0,0-.137.326,1.445,1.445,0,0,0-.005.726,1.183,1.183,0,0,0,.139.326.819.819,0,0,0,.207.233.565.565,0,0,0,.245.107.5.5,0,0,0,.254-.023.642.642,0,0,0,.24-.157Z",
    transform: "translate(-731.179 -257.878)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M815.352,311.256l.574,4.439.047,2.735,1.7.109.253-2.281-.038-6a2.531,2.531,0,0,0-.092-.667,2.09,2.09,0,0,0-.245-.559,1.457,1.457,0,0,0-.367-.4.98.98,0,0,0-.454-.186h0a.872.872,0,0,0-.483.077,1.176,1.176,0,0,0-.408.327,1.781,1.781,0,0,0-.291.527,2.383,2.383,0,0,0-.133.676Z",
    transform: "translate(-730.921 -254.542)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    d: "M824.538,395.631a.378.378,0,0,0-.23-.259.938.938,0,0,0-.458-.049,2.5,2.5,0,0,0-.621.158,4.4,4.4,0,0,0-.719.356,5.134,5.134,0,0,0-.686.5,4.049,4.049,0,0,0-.527.539,2.1,2.1,0,0,0-.315.52.711.711,0,0,0-.051.434.38.38,0,0,0,.235.26.955.955,0,0,0,.464.045,2.543,2.543,0,0,0,.626-.162,4.436,4.436,0,0,0,.721-.36,5.145,5.145,0,0,0,.682-.5,4.012,4.012,0,0,0,.52-.539,2.089,2.089,0,0,0,.31-.514.709.709,0,0,0,.05-.43Z",
    transform: "translate(-740.272 -298.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    d: "M837.689,395.889a.329.329,0,0,0-.268-.2,1.017,1.017,0,0,0-.477.066,3.009,3.009,0,0,0-.62.31,5.456,5.456,0,0,0-.7.533,6.384,6.384,0,0,0-.645.664,4.921,4.921,0,0,0-.475.668,2.434,2.434,0,0,0-.261.595.7.7,0,0,0,0,.443.33.33,0,0,0,.273.2A1.039,1.039,0,0,0,835,399.1a3.061,3.061,0,0,0,.624-.316,5.5,5.5,0,0,0,.7-.539,6.369,6.369,0,0,0,.64-.661,4.886,4.886,0,0,0,.47-.663,2.413,2.413,0,0,0,.258-.589.7.7,0,0,0,0-.439Z",
    transform: "translate(-759.954 -299.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    d: "M844.037,409.215a.34.34,0,0,0-.265-.215,1.029,1.029,0,0,0-.485.044,3,3,0,0,0-.637.283,5.41,5.41,0,0,0-.724.5,6.315,6.315,0,0,0-.676.64,4.874,4.874,0,0,0-.5.652,2.414,2.414,0,0,0-.283.588.71.71,0,0,0-.014.448.343.343,0,0,0,.27.214,1.05,1.05,0,0,0,.49-.049,3.058,3.058,0,0,0,.642-.289,5.461,5.461,0,0,0,.724-.507,6.3,6.3,0,0,0,.671-.64,4.838,4.838,0,0,0,.5-.648,2.4,2.4,0,0,0,.278-.582A.71.71,0,0,0,844.037,409.215Z",
    transform: "translate(-769.34 -305.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    d: "M857.457,414.816a.347.347,0,0,0-.274-.217,1.082,1.082,0,0,0-.5.049,3.155,3.155,0,0,0-.659.294,5.654,5.654,0,0,0-.748.516,6.557,6.557,0,0,0-.7.654,5.03,5.03,0,0,0-.521.668,2.46,2.46,0,0,0-.294.6.711.711,0,0,0-.015.456.349.349,0,0,0,.279.216,1.105,1.105,0,0,0,.508-.053,3.212,3.212,0,0,0,.664-.3,5.709,5.709,0,0,0,.749-.522,6.534,6.534,0,0,0,.693-.655,4.975,4.975,0,0,0,.513-.662,2.437,2.437,0,0,0,.289-.594A.712.712,0,0,0,857.457,414.816Z",
    transform: "translate(-789.273 -308.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M782.633,300.95a4.289,4.289,0,0,1,1.434-.656,3.744,3.744,0,0,1,1.473-.059,4.182,4.182,0,0,1,1.434.517,5.574,5.574,0,0,1,1.319,1.076q-1.147.249-2.3.552t-2.313.662q-1.163.36-2.327.774t-2.34.888a9.319,9.319,0,0,0,.928-.91c.3-.328.588-.675.874-1.017s.578-.68.878-.992A7.052,7.052,0,0,1,782.633,300.95Z",
    transform: "translate(-683.488 -250.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M778.314,303.527l.335.432-.086-.111-.087-.108q-.044-.053-.089-.1l-.09-.1Z",
    transform: "translate(-673.492 -252.034)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M907.313,345.95a5.153,5.153,0,0,1,.328-.557,4.613,4.613,0,0,1,.383-.49,4.1,4.1,0,0,1,.432-.414,3.651,3.651,0,0,1,.47-.332l.626.027q-1.79,4.2-3.912,8.189-2.135,4.009-4.6,7.781-2.482,3.8-5.29,7.332-2.832,3.562-5.991,6.836l4.526-7.316,4.433-7.164,4.343-7.018Z",
    transform: "translate(-858.993 -272.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15513",
    "data-name": "Path 15513",
    d: "M208.611,699.224H458.575a.583.583,0,1,0,0-1.167H208.611a.583.583,0,0,0,0,1.167Z",
    transform: "translate(-74.658 -453.305)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15514",
    "data-name": "Path 15514",
    d: "M382.587,404.41a1.227,1.227,0,0,0,1.162-.835l.623-1.857a1.225,1.225,0,1,0-2.322-.779l-.623,1.857a1.226,1.226,0,0,0,.771,1.551h0a1.222,1.222,0,0,0,.388.064Z",
    transform: "translate(-84.843 -301.302)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15515",
    "data-name": "Path 15515",
    d: "M385.679,414.41a1.226,1.226,0,0,0,1.176-.89l.536-1.885a1.225,1.225,0,0,0-2.356-.67l-.536,1.885a1.226,1.226,0,0,0,1.18,1.56Z",
    transform: "translate(-89.358 -306.39)",
    fill: "#3f3d56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeimg2);
export default __webpack_public_path__ + "static/media/welcomeimg2.c01ce2f658781d0714446fe4e0b6fef8.svg";
export { ForwardRef as ReactComponent };